import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { ISearchResult } from 'types/income';

interface GetSearchResults {
  query: string;
}

export const loaders = {
  getSearchResults: ({ query }: GetSearchResults) =>
    api<{ searchedResults: ISearchResult[] }>({
      url: Endpoints.clientAdmin.search.root.replace(':query', query),
    }),
};
